import axios from 'axios'
import { Message } from 'element-ui'
import Qs from 'qs'
// import router from '../../router'
// import store from '../../store/index'
// import state from '../../store/state'
import { getCookie } from '../../assets/measAssets/js/tools'

// 请求基址
axios.defaults.baseURL = process.env.VUE_APP_API_ADMIN

// 请求拦截
axios.interceptors.request.use((config) => {
    const token = getCookie('token')
    if (token) {
        config.headers['Authorization'] = token
    }
    const ClientType = 1
    if (ClientType) {
        config.headers['ClientType'] = ClientType
    }
    // 携带authtoken
    // if (getCookie('BDPEIMSAuthorization') || state.Authorization) {
    //     config.headers['authorization'] = decode(getCookie('BDPEIMSAuthorization') || state.Authorization)
    // }
    return config
})

// 响应拦截
axios.interceptors.response.use((response) => {
    // console.log(response)
    // if (response.data.code !== '000') {
    //     Message.closeAll()
    //     Message.warning(response.data.msg)
    // }
    // aututoken失效重定向到登录页
    if (response.data.code === '401') {
        // store.commit('removeAccountInfo')
        // router.push({ name: 'Login' })
        top.location.href = window.origin + '/login'
    }
    // response.data.data = response.data.data ? JSON.parse(decode(response.data.data)) : '' // 加密
    // 打印解密的response，不然调个🔨
    return response
})

// 封装post请求 url-请求地址，param-请求参数, config-请求头配置，withCredentials-是否携带证书, isFullUrl-是否完整url
function post(url, param = {}, headers = {}, withCredentials = true, isFullUrl = false) {
    // 是否需要全屏loading 一般弹窗中不需要
    // if (param.needFullScreenLoading === undefined || param.needFullScreenLoading === true) {
    //     store.commit('SET_LOADING', true)
    // }
    // if (isFullUrl) axios.defaults.baseURL = ''
    let config = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    let promise = new Promise((resolve, reject) => {
        axios.post(url, param, config, { withCredentials }).then(
            (res) => {
                // store.commit('SET_LOADING', false)
                resolve(res.data)
            },
            (err) => {
                // store.commit('SET_LOADING', false)
                Message.closeAll()
                Message.error(`系统错误，请联系管理员，错误信息：${err}`)
                reject(err)
            }
        )
    })
    return promise
}
// 封装post请求 url-请求地址，param-请求参数, config-请求头配置，withCredentials-是否携带证书, isFullUrl-是否完整url
function postForm(url, param = {}, headers = { 'Content-Type': 'multipart/form-data' }, withCredentials = true, isFullUrl = false) {
    // 是否需要全屏loading 一般弹窗中不需要
    // if (param.needFullScreenLoading === undefined || param.needFullScreenLoading === true) {
    //     store.commit('SET_LOADING', true)
    // }
    // if (isFullUrl) axios.defaults.baseURL = ''
    let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }
    let promise = new Promise((resolve, reject) => {
        axios.post(url, Qs.stringify(param), config, { withCredentials }).then(
            (res) => {
                // store.commit('SET_LOADING', false)
                resolve(res.data)
            },
            (err) => {
                // store.commit('SET_LOADING', false)
                Message.closeAll()
                Message.error(`系统错误，请联系管理员，错误信息：${err}`)
                reject(err)
            }
        )
    })
    return promise
}

// 封装get请求 url: 请求地址，param: 请求参数
function get(url, param = {}) {
    let promise = new Promise((resolve, reject) => {
        axios.get(url, param).then(
            (res) => {
                resolve(res.data)
            },
            (err) => {
                Message.closeAll()
                Message.error('系统错误，请联系管理员')
                reject(err)
            }
        )
    })
    return promise
}

// 下载流文件
function downloadStreamFile(url, param = {}, downloadName = '下载', isFullUrl = false) {
    // store.commit('SET_LOADING', true)
    let promise = new Promise((resolve, reject) => {
        let instance = axios.create()
        instance.interceptors.request.use((config) => {
            if (getCookie('token')) {
                config.headers['LoginToken'] = getCookie('token')
            }
            return config
        })
        instance.interceptors.response.use((response) => {
            return response.data
        })
        instance.post(url, param, { responseType: 'blob' }).then(
            (res) => {
                // store.commit('SET_LOADING', false)
                if (res.type === 'application/json') {
                    Message.error('下载错误')
                    return false
                }
                let blob = new Blob([res])
                let reader = new FileReader()
                reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
                reader.onload = (e) => {
                    // 转换完成，创建一个a标签用于下载
                    let a = document.createElement('a')
                    a.download = downloadName
                    a.href = e.target.result
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                }
                reader.onerror = (err) => {
                    Message.closeAll()
                    Message.error(err)
                }
                resolve()
            },
            (err) => {
                // store.commit('SET_LOADING', false)
                Message.closeAll()
                Message.error('下载错误')
                reject(err)
            }
        )
    })
    return promise
}
// 七牛上传图片
const postfile = function (url, param) {
    let config = { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 60 * 1000 * 2 }
    let promise = new Promise((resolve, reject) => {
        axios.post(url, param, config).then(function (res) {
            if (res.status === 200) {
                let data = res.data
                if (data.code === '000' || data.fname) {
                    resolve(data)
                } else {
                    reject(data)
                }
            } else {
                Message.error('系统错误，请联系管理员')
            }
        }).catch(error => {
            console.log(error)
        })
    })
    return promise
}

export { post, get, downloadStreamFile, postfile, postForm }
